"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Loading;

var _react = _interopRequireDefault(require("react"));

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

function Loading(_ref) {
  var onClose = _ref.onClose;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-full w-full flex justify-center items-center",
    onClick: onClose
  }, /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], null));
}
//# sourceMappingURL=Loading.js.map